export default class CreateACampaignForm {
    tabs;

    constructor() {
        this.createCampaignForm = document.querySelector('form:has(input[value="levcharity_create_p2p_campaign"][name="action"])');
    }

    init() {
        this.addAjaxLoader();
    }

    addAjaxLoader(){
        if(this.createCampaignForm){
            this.createCampaignForm.addEventListener('submit', function(){
                document.querySelector('body').classList.add('ajax-loading');
            })
        }
    }
}
